<div class="checkbox-group">
  <div class="title">
    {{ title }}
  </div>
  <div class="row">
    <ng-container *ngFor="let option of options">
      <div class="checkbox-container">
        <div class="checkbox" (click)="selectOption($event, option)" (keydown.space)="selectOption($event, option)" tabindex="0">
          <img *ngIf="selectedOptions.includes(option.id)" src="assets/images/icons/check-green.svg" />
        </div>
        <div class="text">{{ option.text }}</div>
      </div>
    </ng-container>
  </div>
  <app-error-message
    type="checkbox-group"
    *ngIf="formControl.errors && formControl.touched"
    [validationErrors]="formControl.errors"
  ></app-error-message>
</div>
